/* Package JSON Import will be here */
import { combineReducers } from "redux";
import { connectRouter } from 'connected-react-router';
import { reducer as formReducer } from "redux-form";
import { localeReducer } from "react-localize-redux";
import { createBrowserHistory } from "history";
/* Package JSON Import will be here */

/* Project Import will be here */
import { types } from "reducers/session";
import {
  localStore, session, profile, notifications, banners, cart, checkout, searchProducts,
  products, orders, orderHistory, wholesalers, hotDeals, categoryMenu, similarProducts, favProduct,
  appSettings, common, promotions, sessionOtpVerification, kpiDashboard, salesReturnProducts, salesReturnSummary,
  smartListProducts, productDetails, recommended, storeDashboard, consumers, storeProducts, storeDisplay,
  paymentInvoiceList, paymentHash, attrFilter, digitalContent, myComplaints, generateComplaints, orderSummaryQty,
  orderStatusDelivery, salesReturnHistory, staticContent, retailerLedger, qpsSchemes, exchangeReturnSummary,
  exchangeOrderProducts, exchangeOrderSummary, exchangeSubmit, historyFilter, supportHelpline, smartListTemplate,
  rewardsOrderProducts, rewardsOrderSummary, rewardsHistory, rewardsAttrFilter, rewardDashboard, appGuidance,
  discounts, myEarningsLedger, clubEnrollment, loyaltyDashboardDetails, survey, invoice, logoutPersist, productPreloadQty
} from "reducers";
/* Project Import will be here */

export const history = createBrowserHistory();

const initialState = {
  router: connectRouter(history), form: formReducer, localStore, session, profile, banners,
  notifications, cart, checkout, searchProducts, products, orders, orderHistory, wholesalers,
  hotDeals, categoryMenu, similarProducts, favProduct, appSettings, common, promotions, sessionOtpVerification,
  kpiDashboard, salesReturnProducts, salesReturnSummary, productDetails, recommended, locale: localeReducer,
  smartListProducts, storeDashboard, consumers, storeProducts, storeDisplay, paymentInvoiceList, paymentHash,
  attrFilter, digitalContent, myComplaints, generateComplaints, orderSummaryQty, orderStatusDelivery,
  salesReturnHistory, staticContent, retailerLedger, qpsSchemes, exchangeReturnSummary, exchangeOrderProducts,
  exchangeOrderSummary, exchangeSubmit, historyFilter, supportHelpline, smartListTemplate, rewardsOrderProducts,
  rewardsOrderSummary, rewardsHistory, rewardsAttrFilter, rewardDashboard, appGuidance, discounts, myEarningsLedger,
  clubEnrollment, loyaltyDashboardDetails, survey, invoice, logoutPersist, productPreloadQty
};

const appReducer = combineReducers(initialState);

const rootReducer = (state, action) => {
  if (action.type === types.LOG_OUT)
    state = { locale: state.locale, router: state.router, logoutPersist: state.logoutPersist };

  return appReducer(state, action);
};

export default rootReducer;